export default {
    deep: false,
    immediate: true,
    once: false,
    evaluateAll: false
};
